import { render } from "./FormSection.vue?vue&type=template&id=5db009b0"
import script from "./FormSection.vue?vue&type=script&lang=ts"
export * from "./FormSection.vue?vue&type=script&lang=ts"
script.render = render

export default script